<template>
	<div>
		<ul class="mt20 workuls" v-if="list.length != 0">
			<li class="listHover" :class="[listNum==3?'three':'four']" v-for="(item,index) in list" :key="index"
				@click="toDetails(item)">
				<el-image class="t_img" fit="cover" :src="item.picture" />
				<div class="listcon">
					<div class="worltitle">{{item.title}}</div>
					<div class="wr-l_tag">
						<el-tag v-if="item.originalWork" effect="plain" size="mini">
							原创作品
						</el-tag>
						<el-tag v-else effect="plain" size="mini" type="warning">
							佳作分享
						</el-tag>

					</div>
					<div class="nabx">
						<el-image fit="cover" :src="item.userAvatar">
						</el-image>
						<div class="wouser">{{item.userName}}</div>
					</div>
					<div class="htime">
						{{item.createTime | dateFormat}}
						<span>·</span>
						{{item.viewCount>0?item.viewCount:0}} 浏览
						<span>·</span>
						{{item.favourCount>0?item.favourCount:0}} 喜欢
					</div>
				</div>
			</li>
		</ul>
		<div v-else>
			<h2 class="no_list_h2">暂无作品</h2>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'moreworks',
		components: {},
		props: {
			showPage: {
				default: true,
				type: Boolean
			},
			listNum: {
				default: 4,
				type: [
					Number, String
				]
			},
			list: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				currentPage: 1,
			}
		},
		methods: {
			toDetails(item) {
				const {
					href
				} = this.$router.resolve({
					name: "workdetails",
					query: {
						workId: item.workId
					}
				})
				window.open(href, '_blank')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.wr-l_tag {
		margin-bottom: 10px;
	}

	.workuls {
		li.four {
			margin-right: 2%;
			width: 23.5%;
		}

		li.four:nth-child(4n) {
			margin-right: 0;
		}

		li.three {
			margin-right: 2%;
			width: 32%;
		}

		li.three:nth-child(3n) {
			margin-right: 0;
		}

		li {
			float: left;
			margin-bottom: 2%;
			background-color: white;
			border-radius: 10px;
			overflow: hidden;

			.t_img {
				height: 240px;
				border-radius: 6px;
				margin: 16px 16px 0 16px;
			}

			.listcon {
				padding: 14px;

				.el-tag {
					margin-right: 8px;
					border-radius: 10px !important;
				}

				.worltitle {
					font-weight: bold;
					margin-bottom: 4px;
					font-size: 16px;
				}

				.nabx {
					display: flex;
					align-items: center;

					.el-image {
						width: 30px;
						height: 30px;
						overflow: hidden;
						border-radius: 100%;
						margin-right: 10px;
					}

					.wouser {
						font-size: 14px;
						color: var(--info);
					}
				}

				.htime {
					margin-top: 10px;
					color: var(--info);

					span {
						margin: 0 6px;
						display: inline-block;
					}
				}
			}
		}




	}

	.workuls:after {
		content: '';
		display: block;
		clear: both;
		visibility: hidden;
	}

	/deep/ .el-pager li,
	/deep/ .el-pagination .btn-prev,
	/deep/ .el-pagination .btn-next,
	/deep/ .el-input__inner {
		background-color: transparent !important
	}
</style>
